import $ from "jquery";
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(function() {
  
  if ($('form#invite_client').length === 0) { return; }
  
  $(document).on("ajax:success", "form#invite_client", function(event, data, status, xhr) {
    return $(this).html(`\
<p>
  You have successfully invited ${data.email}
</p>
<p>
  <a href=\"javascript:location.reload(true)\" class=\"radius button\">OK</a>
</p>\
`);
  });
  
  $(document).on("ajax:error", "form#invite_client", function(event, xhr, status, error) {
    const errors = JSON.parse(xhr.responseText);
    if (errors.email) {
      return $(this).find('label').text(`Email ${errors.email}`).css({color: 'red'});
    }
  });
  
  return $('form#invite_client input[type=submit]').click(function() {
    return $(this).closest('form').find('label').text("Email").css({color: 'black'});
  });
});
